const wishlistHandles = JSON.parse(localStorage.getItem('wishlist')) || [];
const storefrontApiToken = '0c768b7f91b937ae014556c1d8e879a2';

displayPrice = (product) => {
  const price = parseFloat(product.variants.edges[0].node.price.amount).toFixed(2);
  return `$${price.endsWith('.00') ? price.slice(0, -3) : price}`;
};

const displayWishlist = (products) => {
  const wishlistContainer = document.querySelector('#wishlist__grid');

  products.forEach((product) => {
    if (!product) {
      return;
    }
    const productElement = document.createElement('li');
    productElement.classList.add('grid__item', 'scroll-trigger', 'animate--slide-in');

    productElement.innerHTML = `
        <div class="card-wrapper card-wrapper--product underline-links-hover">
          <comparison-button data-collection-handle="wishlist" data-product-handle="${product.handle}">
            <label><input type="checkbox">Compare</label>
          </comparison-button>
          <wishlist-button data-product-handle="${product.handle}">
            <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12.442 1.86335C11.7346 1.17287 10.7966 0.753057 9.79879 0.680273C8.80095 0.607488 7.80948 1.00634 7.00468 1.58652C6.15687 0.97121 5.10162 0.572427 4.05142 0.685901C3.00122 0.799374 2.0341 1.2969 1.34479 2.07829C0.655488 2.85969 0.29521 3.8669 0.336508 4.89711C0.377807 5.92731 0.817615 6.90399 1.56737 7.63046L6.53158 12.4743C6.59353 12.5352 6.66722 12.5836 6.74842 12.6166C6.82962 12.6496 6.91672 12.6666 7.00468 12.6666C7.09265 12.6666 7.17974 12.6496 7.26094 12.6166C7.34214 12.5836 7.41584 12.5352 7.47778 12.4743L12.442 7.63046C12.8302 7.25187 13.1382 6.80235 13.3484 6.30758C13.5585 5.8128 13.6666 5.28248 13.6666 4.74691C13.6666 4.21133 13.5585 3.68101 13.3484 3.18623C13.1382 2.69146 12.8302 2.24194 12.442 1.86335ZM7.00468 11.0959L2.5069 6.7137C2.11055 6.32535 1.84055 5.83144 1.73077 5.29393C1.621 4.75642 1.67633 4.19925 1.88984 3.69231C2.10335 3.18537 2.46552 2.75124 2.93092 2.44437C3.39633 2.1375 3.94423 1.97157 4.50592 1.96738C5.25629 1.96918 5.97526 2.38126 6.50493 2.89988C6.56687 2.96082 6.64057 3.00919 6.72177 3.0422C6.80297 3.07521 6.89006 3.0922 6.97803 3.0922C7.06599 3.0922 7.15309 3.07521 7.23429 3.0422C7.31549 3.00919 7.38918 2.96082 7.45113 2.89988C7.99641 2.43883 8.70084 2.07736 9.42185 2.10394C10.1429 2.13052 10.8266 2.42339 11.3347 2.92327C11.8427 3.42316 12.1372 4.09272 12.1585 4.79644C12.1797 5.50017 11.9262 6.18549 11.4492 6.7137L7.00468 11.0959Z" fill="#8E1E4D"/>
            </svg>
          </wishlist-button>
          <a href="/products/${product.handle}">
            <img src="${product.images.edges[0].node.src}" alt="${product.title}">
            <span class="product__vendor">${product.vendor}</span>
            <span class="product__title">${product.title}</span>
            <span class="product__price">${this.displayPrice(product)}</span>
          </a>
        </div>`;

    wishlistContainer.appendChild(productElement);
  });
};

const generateProductQuery = (handle, index) => `
  product${index}: productByHandle(handle: "${handle}") {
    id
    title
    handle
    description
    vendor
    priceRange {
      minVariantPrice {
        amount
        currencyCode
      }
    }
    images(first: 1) {
      edges {
        node {
          src
        }
      }
    }
    variants(first: 1) {
      edges {
        node {
          price {
            amount
            currencyCode
          }
        }
      }
    }
  }
`;

const query = `
  query {
    ${wishlistHandles.map((handle, index) => generateProductQuery(handle, index)).join('\n')}
  }
`;

async function fetchProductData() {
  try {
    const response = await fetch('/api/2023-04/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': storefrontApiToken,
      },
      body: JSON.stringify({ query }),
    });

    const data = await response.json();

    if (data.errors) {
      console.error('GraphQL errors:', data.errors);
      return [];
    }

    const products = wishlistHandles.map((_, index) => data.data[`product${index}`]);
    return products;
  } catch (error) {
    console.error('Error fetching product data:', error);
    return [];
  }
}

if (wishlistHandles.length > 0) {
  fetchProductData().then((products) => {
    displayWishlist(products);
  });
} else {
  const wishlistContainer = document.querySelector('#wishlist__grid');
  wishlistContainer.innerHTML = '<p>Your wishlist is empty.</p>';
}
